export const ActionRefreshData: string = 'actionRefreshData';

export const useActionRefreshData = () => {
  const { onPlay, complete } = useAbstractAction(
    ActionRefreshData,
    true,
    -1,
    []
  );

  const context = useContextStore();

  onPlay(async () => {
    try {
      await context.loadDataFromNetwork(false);
      complete(true);
    } catch (e) {
      complete(false);
    }
  });
};
